import App from "./App.vue";
import { createApp } from "vue";
import { translate } from "@/libs/webPlugin";
import { createPinia } from "pinia";
import { webRouter as router } from "./router/web";
import WlSvg from "@wltech/svg";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { SentryInit } from "@wltech/hooks/src/useSentryConfig";

import "ant-design-vue/dist/reset.css";
import "@/static/styles/main.css";
import "virtual:uno.css";
import "uno.css";
import "@/libs/antdvConfig"; // 导入 Ant Design Vue 全局配置
import { prewarmFingerprint } from "@/libs/fingerprint";

// @ts-ignore
import "@/libs/track";

// @ts-ignore
import "../public/monitor-lc.js";
const VITE_MODE = import.meta.env.VITE_MODE;

window.LCTrack.init({
  istest: VITE_MODE !== "prd",
  abbrev_name: "LC Middle page",
});

prewarmFingerprint();

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
app.use(router);
app.use(translate);
app.use(WlSvg);
pinia.use(piniaPluginPersistedstate);
SentryInit({
  app,
  router,
  environment: import.meta.env.VITE_MODE,
  domin: import.meta.env.VITE_APP_DOMAIN,
  dsn: import.meta.env.VITE_SENTRY_DSN_WEB,
});
app.mount("#app");

import { initRouterHooks } from "@/permission";
initRouterHooks(router, "web");
